import { VKShareButton, VKIcon } from "react-share";
import { TelegramShareButton, TelegramIcon } from "react-share";
import { OKShareButton, OKIcon } from "react-share";
import Stack from "@mui/material/Stack";
import { API_MEDIA } from "../../env";
import { grey } from "@mui/material/colors";
import IconButton from "@mui/material/IconButton";

export default function RepostFunc({ data }) {
  // const shareUrl = "http://localhost:3000/";
  const shareUrl = window.location.href;
  const title = "Федерация пауэрлифтинга Рязани";
  // const image = data ? API_MEDIA + data[0].image : shareUrl;
  // const image = API_MEDIA + data.newimages[0];
  const image = data ? API_MEDIA + data.newimages[0].image : shareUrl;
  // const image = data.newimages[0].image;
  // console.log(image);
  return (
    <Stack direction="row" spacing={0} justifyContent="space-around">
      <IconButton aria-label="телеграмм">
        <TelegramShareButton
          title={title}
          image={image}
          url={shareUrl}
          aria-label="телеграмм"
        >
          <TelegramIcon size={20} round bgStyle={{ fill: grey[400] }} />
        </TelegramShareButton>
      </IconButton>

      <IconButton aria-label="вконтакте">
        <VKShareButton
          image={image}
          noParse
          noVkLinks
          title={title}
          url={shareUrl}
          aria-label="вконтакте"
        >
          <VKIcon size={20} round bgStyle={{ fill: grey[400] }} />
        </VKShareButton>
      </IconButton>

      <IconButton aria-label="одноклассники">
        <OKShareButton
          title={title}
          url={shareUrl}
          description="одноклассники"
          image={image}
          aria-label="одноклассники"
          // bgStyle={{ fill: "black" }}
        >
          <OKIcon size={20} round bgStyle={{ fill: grey[400] }} />
        </OKShareButton>
      </IconButton>
    </Stack>
  );
}
